import React, { useState } from "react";
import { clearCurrentVehicleAssignmentDetail } from "Redux/Dashboard/slice";
import VehicleAssignment from "./VehicleAssignment";
import { Grid } from "@mui/material";
import VehicleAssignmentDetail from "./VehicleAssignmentDetail";

const VehicleAssignmentDashboard = () => {
  const [detailVehicleAssignment, setDetailVehicleAssignment] =
    useState<boolean>(false);
  const [assignmentId, setAssignmentId] = useState<string | null>(null);

  const openDetailVehicleAssignment = () => setDetailVehicleAssignment(true);
  const closeDetailVehicleAssignment = () => {
    setDetailVehicleAssignment(false);
    clearCurrentVehicleAssignmentDetail();
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={detailVehicleAssignment ? 8 : 12}>
        <VehicleAssignment
          assignmentId={assignmentId}
          setAssignmentId={setAssignmentId}
          closeDetailAssigment={closeDetailVehicleAssignment}
          openDetailAssigment={openDetailVehicleAssignment}
        />
      </Grid>
      <Grid item xs={4}>
        {detailVehicleAssignment && (
          <VehicleAssignmentDetail
            setAssignmentId={setAssignmentId}
            closeModal={closeDetailVehicleAssignment}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default VehicleAssignmentDashboard;
